import moment from "moment";

export const getType = (type) => {
  switch (type) {
    case 'mineSite':
      return 'Mine Site';
    case 'village':
      return 'Village';
    default:
      return 'Location';
  }
}

export const dateFormat = (type, date) => {
  switch (type) {
    case 'daily':
    case 'threeMonths':
    case 'weekly':
    case 'monthly':
    case 'year':
      return date.format('YY MM DD').toString();
    default:
      return date.toISOString();
  }
}

export const getDateRanges = (type) => {
  switch (type) {
    case 'daily':
      return [moment()].map((d) => dateFormat('weekly', d));
    case 'weekly':
      return Array.from(moment.range(
        moment().subtract(1, 'weeks'),
        moment()
      ).by('day')).map((d) => dateFormat('weekly', d));
    case 'monthly':
      return Array.from(moment.range(
        moment().subtract(1, 'months'),
        moment()).by('day')
      ).map((d) => dateFormat('monthly', d));
    case 'threeMonths':
      return Array.from(moment.range(
        moment().subtract(3, 'months'),
        moment()).by('day')
      ).map((d) => dateFormat('monthly', d));
    case 'year':
      return Array.from(moment.range(
        moment().subtract(12, 'months'),
        moment()).by('day')
      ).map((d) => dateFormat('monthly', d));
    default:
      return [];
  }
}

export const filterValidGPS = (data) => {
  const latCheck = (lat) => lat > -90 || lat < 90;
  const lngCheck = (lng) => lng > -180 || lng < 180;
  return data.filter(item => {
    return item.marker &&
      latCheck(Number(item.marker.lat)) &&
      lngCheck(Number(item.marker.lng));
  });
}

export const mapFiltersConfig = (data) => {
  return {
    location: [
      {
        type: 'input',
        label: 'Dashboard::Search location',
        placeholder: 'Dashboard::Location Name',
        dest: 'locationName',
      },
      {
        type: 'checkbox',
        label: 'Dashboard::Show/hide types of locations',
        dest: 'type',
        options: [
          { label: 'Mine Sites', value: 'mineSite', marker: '/assets/images/dashboard/map-icons/minesites-location-icon.svg', default: true, },
          { label: 'Villages', value: 'village', marker: '/assets/images/dashboard/map-icons/villages-location-icon.svg', default: true, },
          { label: 'Other', value: 'other', marker: '/assets/images/dashboard/map-icons/other-location-icon.svg', default: true, },
        ],
      },
    ],
    event: [
      {
        type: 'radio',
        label: 'Dashboard::Choose period',
        dest: 'period',
        options: [
          {
            label: 'Dashboard::All',
            value: 'all',
            default: true,
          },
          {
            label: 'Dashboard::One Month',
            value: 'monthly',
          },
          {
            label: 'Dashboard::3 Months',
            value: 'threeMonths',
          },
          {
            label: 'Dashboard::12 Months',
            value: 'year',
          },
        ],
      },
      {
        type: 'select',
        label: 'Category',
        placeholder: 'Dashboard::Select category',
        dest: 'riskTypes',
        options: data?.categoryOptions || [],
      },
      {
        type: 'select',
        label: 'Type',
        placeholder: 'Dashboard::Select type',
        dest: 'riskSubTypes',
        options: (data?.typeOptions || []).map((o) => ({
          ...o,
          filter: { riskTypes: (o?.filters[0]?.value || [])[0] }
        })),
      },
    ],
  }
}
